import * as React from "react";
import { SVGProps } from "react";
const SvgStop = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.9 24h-9.8C9.4 24 8 22.6 8 20.9v-9.8C8 9.4 9.4 8 11.1 8h9.8c1.7 0 3.1 1.4 3.1 3.1v9.8c0 1.7-1.4 3.1-3.1 3.1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStop;
